import { Injectable } from '@angular/core';
import { ErrorPanelService } from '../../services/error-panel.service';
import { PatientService } from '../../services/patient.service';
import { environment } from '../../../environments/environment';
import {
  modifyCalendarEvent,
  newCalendarEvent,
  newPatientAndAppointment,
} from '../../models/calendar-model';
import { CalendarUtilsService } from './calendar-utils.service';
import { GmailService } from '../../services/gmail.service';
import { AppointmentCreate } from '../../models/appointment-model';

@Injectable({
  providedIn: 'root',
})
export class DbAppointmentsService {
  constructor(
    private errorPanelService: ErrorPanelService,
    private patientService: PatientService,
    private calendarUtils: CalendarUtilsService,
    private gmailService: GmailService
  ) {}

  addAppointmentToDb(
    newEvent: newCalendarEvent,
    googleEventId: string
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      const newAppointment: AppointmentCreate = {
        patient_id: newEvent.patientId,
        date: newEvent.date,
        start_time: newEvent.time,
        end_time: this.calendarUtils.calculateEndTime(
          newEvent.time,
          newEvent.lenght
        ),
        title: newEvent.title,
        google_calendar_event_id: googleEventId,
        is_remote: newEvent.isRemote,
      };

      this.patientService.createAppointment(newAppointment).subscribe({
        next: (appointment: AppointmentCreate) => {
          this.gmailService.prepareEmailForClient(appointment);
          resolve(appointment);
        },
        error: (err) => {
          console.error('Errore nel creare appuntamento', err);
          this.errorPanelService.showErrorSnackBar(
            `Errore nel creare l\'appuntamento ${newEvent.title}`
          );
          reject(err);
        },
      });
    });
  }

  updateAppointmentInDb(psicogeniusId: string, data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.patientService.putAppointment(psicogeniusId, data).subscribe({
        next: (appointment) => {
          this.gmailService.prepareEmailForClient(appointment);
          resolve(appointment);
        },
        error: (err) => {
          console.error('Errore nel aggiornare appuntamento', err);
          this.errorPanelService.showErrorSnackBar(
            `Errore nell'aggiornare l'appuntamento ${data.title}`
          );
          reject(err);
        },
      });
    });
  }

  deleteAppointmentFromDb(
    psicogeniusId: string,
    appointmentTitle: string
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      this.patientService.deleteAppointment(psicogeniusId).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          console.error('Errore nella eliminazione del appuntamento', err);
          this.errorPanelService.showErrorSnackBar(
            `Errore nella eliminazione dell'appuntamento ${appointmentTitle}`
          );
          reject(err);
        },
      });
    });
  }

  deletePatientAppointment(appointmentId: string): Promise<void> {
    return new Promise((resolve, reject) => {
      this.patientService.deleteAppointment(appointmentId).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (error) => {
          console.error('Qualcosa è andato storto', error);
          this.errorPanelService.showErrorSnackBar(
            "Errore nel cancellare l'appuntamento"
          );
          reject(error);
        },
      });
    });
  }

  updatePatientAppointment(
    appointmentId: string,
    newEvent: newPatientAndAppointment,
    googleEventId?: string
  ): Promise<void> {
    return new Promise((resolve, reject) => {
      const putAppointment = {
        date: newEvent.date,
        start_time: newEvent.time,
        end_time: this.calendarUtils.calculateEndTime(
          newEvent.time,
          newEvent.lenght
        ),
        title: newEvent.title,
        ...(googleEventId && { google_calendar_event_id: googleEventId }),
      };

      this.patientService
        .putAppointment(appointmentId, putAppointment)
        .subscribe({
          next: (response) => {
            this.gmailService.prepareEmailForClient(response);
            resolve(response);
          },
          error: (error) => {
            console.error('Qualcosa è andato storto', error);
            this.errorPanelService.showErrorSnackBar(
              "Errore nel modificare l'appuntamento"
            );
            reject(error);
          },
        });
    });
  }
}
